import type { ReactNode } from "react"

import { SiteHeader } from "@/components/site-header"

// Persistent layout wrapped around every Inertia page (wired in
// entrypoints/inertia.tsx). Pages keep owning their own <main>; the layout only
// supplies shared chrome that must be present everywhere.
export function AppLayout({ children }: { children: ReactNode }) {
  return (
    <>
      <SiteHeader />
      {children}
    </>
  )
}
